import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/contact')({
  ssr: false, // CSR only
})
